import React from 'react';

class DashboardContainer extends React.Component {
  render() {
    return (
      <div>Admin Dashboard</div>
    );
  }
}

// --------------------------------------------------------
// Public API
// --------------------------------------------------------

export default DashboardContainer;
